module.exports = __webpack_public_path__ + "static/debug-tool-c283cd0f85e18d2c03be2abfa2692e13.png";